import { request } from "./http";
import type { AppNotification } from "./types";

export function listNotifications(unreadOnly = false): Promise<AppNotification[]> {
  return request("/notifications/", {
    params: { unread_only: unreadOnly || undefined },
  });
}

export function unreadCount(): Promise<{ count: number }> {
  return request("/notifications/unread-count");
}

export function markRead(id: string): Promise<{ ok: boolean }> {
  return request(`/notifications/${id}/read`, { method: "POST" });
}

export function markAllRead(): Promise<{ marked_read: number }> {
  return request("/notifications/read-all", { method: "POST" });
}
